module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"phone-number":"Número de telefone"},"en-US":{"phone-number":"Phone  number"}}')
  delete Component.options._Ctor
}
